/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface PharmacyAddress {
  /** Street address lines */
  line?: string[];
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Postal or ZIP code */
  postalCode?: string;
}
